/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import * as Recon from './recon.reducers'

export default Recon

// @TODO: Migrate recon.reducers to this file.
